import {ReactComponent} from "./ic_route_arrow.svg";
import styled from "styled-components";

interface RouteArrowIconProps {
    color?: string;
    size?: number;
}

const StyledIcon = styled(ReactComponent)<RouteArrowIconProps>`
  width: ${({size}) => size}px;
  height: ${({size}) => size}px;

  path {
    fill: ${({color}) => color};
  }
`;

const RouteArrowIcon: React.FC<RouteArrowIconProps> = (
    {
        color = '#09121F',
        size = 24,
    }) => <StyledIcon color={color} size={size}/>;

export default RouteArrowIcon;
